"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerificationLoading = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const RootLoader = (0, _mui.styled)('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  textAlign: 'center'
});
const VerificationLoading = exports.VerificationLoading = /*#__PURE__*/(0, _react.memo)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)(RootLoader, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.CircularProgress, {
    color: "primary",
    sx: {
      '&.MuiCircularProgress-root': {
        color: '#999999'
      }
    }
  })
}));